import "react";
import { jsx as e } from "react/jsx-runtime";
//#region src/components/atoms/Icon/SVGs/chevronUp.svg
var t = (t) => /* @__PURE__ */ e("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 18 16",
	...t,
	children: /* @__PURE__ */ e("path", {
		fill: "#1f2830",
		d: "M15.087 12.14 9.204 6.26a.287.287 0 0 0-.408 0l-5.883 5.88a1.149 1.149 0 0 1-1.9-1.25 1.2 1.2 0 0 1 .274-.373L7.78 4.024a1.725 1.725 0 0 1 2.44 0l6.493 6.493a1.15 1.15 0 1 1-1.626 1.623"
	})
});
//#endregion
export { t as default };
